// extracted by mini-css-extract-plugin
export default {"tooltip":"so-z","sharingV2":"to-z","sharingIconsV2":"uo-z","links":"vo-z","link":"wo-z","facebookV2":"xo-z","twitterV2":"yo-z","pinterestV2":"zo-z"};